<template>
  <div class="workAddDemand">
    <el-form ref="form" class="workAddDemand_form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="提出人" prop="userName" v-if="type == 2">
        <el-input v-model="form.userName" placeholder="请输入提出人" />
      </el-form-item>
      <el-form-item label="收益类型" prop="incomeType">
            <el-radio-group v-model="form.incomeType">
              <el-radio :label="1">奖金</el-radio>
              <el-radio :label="2">其他</el-radio>
              <el-radio :label="3">无</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="奖金" prop="money" v-if="form.incomeType == 1">
            <el-input v-model="form.money" placeholder="请输入奖金" />
          </el-form-item>
          <el-form-item label="说明" prop="incomeRemark" v-if="form.incomeType == 2">
            <el-input v-model="form.incomeRemark" placeholder="请输入说明" />
          </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题" />
      </el-form-item>
      <el-form-item label="内容">
        <editor v-model="form.content" :min-height="192"/>
      </el-form-item>
      <el-form-item label="附件" prop="file">
        <file-upload v-model="form.file" :limit="9" />
      </el-form-item>
      <el-form-item label="紧急程度" prop="level" >
        <span :class="form.level == 1 ? 'colorBox_actived colorBox' : 'colorBox'" @click="levelChange(1)"
          style="background: #F56C6C;"></span>
        <span :class="form.level == 2 ? 'colorBox_actived colorBox' : 'colorBox'" @click="levelChange(2)"
          style="background: #E6A23C;"></span>
        <span :class="form.level == 3 ? 'colorBox_actived colorBox' : 'colorBox'" @click="levelChange(3)"
          style="background: #409EFF;"></span>
        <el-input v-model="form.level" placeholder="请输入紧急程度" style="opacity: 0;"/>
      </el-form-item>
    </el-form>
    <div class="btnBox">
      <el-button type="primary" class="btnBox_btn" @click="submitForm" :disabled="submitShow">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { getInfo, addDemand, updateDemand,getDemand } from '@/api/workOrder'
import Cookies from 'js-cookie'
export default {
  name: "workAddDemand",
  data() {
    return {
      // 表单参数
      form: {
        level: '',
        file: '',
        phone: '',
        userName: '',
        userId: '',
        content: '',
        title: '',
        companyId: this.$route.params.companyId
      },
      // 表单校验
      rules: {
        incomeType: [
          { required: true, message: "收益类型不能为空", trigger: "change" }
        ],
        title: [
          { required: true, message: "标题不能为空", trigger: "blur" }
        ],
        content: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ],
        level: [
          { required: true, message: "紧急程度不能为空", trigger: "blur" }
        ],
      },
      userInfo: {},
      type: 1,
      submitShow: false,
      detailsInfo: {},
      isEdit: false
    };
  },
  mounted() {
    console.log(this.$route.params)
    if (this.$route.params.userId && this.$route.params.userId != 'undefined' ) {
      this.getuser()
      this.type = 1
    } else {
      this.type = 2
      this.form.phone = Cookies.get('externalPhone')
    }
    if(this.$route.params.id&& this.$route.params.id !='null' ){
      this.getDetalis()
      console.log(123)
      this.isEdit = true
    }else{
      this.isEdit = false
      console.log(456)
    }
  },
  methods: {
    getDetalis(){
      this.loading = true;
      getDemand(  this.$route.params.id ).then(response => {
        let rows =  response.data;
        if(rows.file){
          rows.fileList = rows.file.split(',')
        }else{
          rows.fileList =[]
        }
        this.form = rows
      });
    },
    levelChange(type) {
      console.log(type)
      this.form.level = type
      console.log(this.form.level)
    },
    getuser() {
      getInfo({
        companyId: this.$route.params.companyId,
        id: this.$route.params.userId
      }).then(response => {
        console.log(response)
        const user = response.data
        this.userInfo = response.data
        this.form.phone = user.phone
        this.form.userName = user.name
        this.form.userId = user.id
        console.log(this.form)
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.submitShow = true
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateDemand(this.form).then(response => {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              setTimeout(() => {
                this.$router.go(-1)
                this.submitShow = false
              }, 3000); // 2000毫秒后显示消息
            });
          } else {
          this.form.type =    Cookies.get("notAuthorized")*1;
            addDemand(this.form).then(response => {
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              setTimeout(() => {
                this.$router.go(-1)
                this.submitShow = false
              }, 3000); // 2000毫秒后显示消息
            });
          }
        }
      });
    },
  },
};
</script>
<style scoped>

.workAddDemand {
  padding: 10px;
  padding-left: 0;
  height: 95vh;
}

.workAddDemand_form {
  width: calc(100% - 10px);
}

.colorBox {
  display: inline-block;
  width: 25px;
  height: 25px;
  border-radius: 3px;
  margin-right: 10px;
}

.colorBox_actived {
  border: 1px solid #000;
}

.btnBox {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}

.btnBox_btn {
  width: 90%;
}
</style>
<style>
.workAddDemand .el-icon-document {
  width: auto !important;
}
</style>